import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import { notificationController } from "components/Common/Notification/Notification";
import websiteLogo from "../../images/logo.png";
import Button from "components/Common/Button";
import { resetPassword } from "api/user.api";

const ResetPassword = () => {
  const navigate = useNavigate();
  const params = useParams();
  console.log("params: ", params);
  const [isLoading, setLoading] = useState(false);

  const uid = params.uid || "";
  const token = params.token || "";

  const initialValues = {
    newPassword: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .min(8, "Password must be at least 8 characters long")
      .required("New Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword")], "Passwords must match") // Removed `null`
      .required("Confirm Password is required"),
  });

  const handleSubmit = async (values: { newPassword: string; confirmPassword: string }) => {
    setLoading(true);
      try {
        if (uid !== "" && token !== "") {
          await resetPassword({uid: uid, token: token, new_password: values.newPassword});
          notificationController.success({
            message: "Password reset email sent! Please check your inbox.",
          });
          navigate("/auth/login");
        } else {
          notificationController.error({
            message: `Invalid url`,
          });
        }
      } catch (error) {
        notificationController.error({
          message: `Password reset Error: ${error}`,
        });
      } finally {
        setLoading(false);
      }
  };

  return (
    <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img className="mx-auto h-10 w-auto" src={websiteLogo} alt="Your Company" />
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
          Reset your password
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Enter your new password to reset your account password.
        </p>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          <Form className="space-y-6">
            <div>
              <label htmlFor="newPassword" className="block text-sm font-medium leading-6 text-gray-900">
                New Password
              </label>
              <div className="mt-2">
                <Field
                  id="newPassword"
                  name="newPassword"
                  type="password"
                  autoComplete="new-password"
                  required
                  className="p-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
                <ErrorMessage name="newPassword" component="div" className="text-red-500 text-sm mt-1" />
              </div>
            </div>

            <div>
              <label htmlFor="confirmPassword" className="block text-sm font-medium leading-6 text-gray-900">
                Confirm Password
              </label>
              <div className="mt-2">
                <Field
                  id="confirmPassword"
                  name="confirmPassword"
                  type="password"
                  autoComplete="new-password"
                  required
                  className="p-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
                <ErrorMessage name="confirmPassword" component="div" className="text-red-500 text-sm mt-1" />
              </div>
            </div>

            <Button
              type="submit"
              isLoading={isLoading}
              variant="primary"
              className="bg-primary text-white px-3 py-2 rounded-md w-[100%]"
            >
              Reset Password
            </Button>
          </Form>
        </Formik>

        <p className="mt-10 text-center text-sm text-gray-500">
          Remembered your password?{" "}
          <button
            type="button"
            onClick={() => navigate("/auth/login")}
            className="font-semibold text-primary hover:text-indigo-600"
          >
            Sign in
          </button>
        </p>
      </div>
    </div>
  );
};

export default ResetPassword;
